'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import styles from '../layout.module.css';

export default function ClientAuthHeader() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const accessToken = localStorage.getItem('ynab_access_token');
    setIsAuthenticated(!!accessToken);
  }, []);

  if (!isAuthenticated && pathname !== '/authorize') {
    return null;
  }

  return (
    <nav className={styles.nav}>
      {isAuthenticated && (
        <>
          <Link
            href="/upload"
            className={`${styles.navLink} ${pathname === '/upload' ? styles.active : ''}`}
          >
            Upload Files
          </Link>
          <Link
            href="/report"
            className={`${styles.navLink} ${pathname === '/report' ? styles.active : ''}`}
          >
            Reports
          </Link>
          <Link
            href="/gallery"
            className={`${styles.navLink} ${pathname === '/gallery' ? styles.active : ''}`}
          >
            Gallery
          </Link>
        </>
      )}
    </nav>
  );
}
